import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IUserData } from '../../index';

export interface IChangeStatusUserRequestAction {
  data: {
    id: number;
    isActive: boolean;
  };
  functions: {
    error(err: any): void;
    success(message: string): void;
  };
}

function changeStatusRequest(
  draft: Draft<IUserData>,
  _: PayloadAction<IChangeStatusUserRequestAction>,
) {
  draft.changeStatus.config.isLoading = true;
}

export default changeStatusRequest;
